import { service } from '../../../../helpers/http'

//Retorna a lista com as categorias de grupos
export const ActionGetGroupStatus = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupStatus',
        action: 'getGroupStatus',
        payload: payload
    })
    
}

//Cadastra uma nova categoria de grupo
export const ActionPostGroupStatus = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupStatus',
        action: 'postGroupStatus',
        payload: payload
    })
    
}

//Atualiza uma categoria de grupo
export const ActionPutGroupStatus = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupStatus',
        action: 'putGroupStatus',
        payload: payload
    })
    
}

//Deleta uma categoria de grupo
export const ActionDeleteGroupStatus = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupStatus',
        action: 'deleteGroupStatus',
        payload: payload
    })
    
}